import React from 'react';

const Header = () => {
  return (
    <header>
      <div className="header">
        <h1>Erin Tynan</h1>
        <p>
          <a href="https://www.linkedin.com/in/erintynan">LinkedIn</a> | 
          <a href="mailto:ettynan@csu.fullerton.edu">ettynan@csu.fullerton.edu</a> | 
          US Citizen |  
          <a href="https://github.com/ettynan">GitHub</a>
        </p>
      </div>
    </header>
  );
};

export default Header;
